import { Menu } from "lucide-react";
import Breadcrumbs from "./Breadcrumbs";
import QuickSearchBar from "./QuickSearchBar";
import HeaderActions from "./HeaderActions";
import styles from "./TopHeader.module.css";

const TopHeader = ({
  title,
  onOpenMobile,
  onToggleCollapse,
  searchQuery,
  onSearchChange,
  theme,
  onToggleTheme,
  authUser,
  onOpenProfile,
}) => {
  return (
    <header className={styles.header}>
      <div className={styles.leftGroup}>
        {/* Mobile Hamburger */}
        <button
          type="button"
          onClick={onOpenMobile}
          className={styles.hamburger}
          aria-label="Open mobile menu"
        >
          <Menu size={20} />
        </button>

        {/* Desktop Collapse Toggle */}
        <button
          type="button"
          onClick={onToggleCollapse}
          className={styles.desktopToggle}
          aria-label="Toggle sidebar"
          title="Toggle sidebar"
        >
          <Menu size={18} />
        </button>

        {/* Dynamic Breadcrumbs */}
        <Breadcrumbs customTitle={title} />
      </div>

      <div className={styles.centerGroup}>
        <QuickSearchBar
          value={searchQuery}
          onChange={onSearchChange}
        />
      </div>

      <HeaderActions
        theme={theme}
        onToggleTheme={onToggleTheme}
        authUser={authUser}
        onOpenProfile={onOpenProfile}
      />
    </header>
  );
};

export default TopHeader;
